<template>
  <div class="info">
    <img :src="imageSource(devicein.deviceType)" class="deviceimg" alt="..." />
    <div class="verticalline"></div>
    <div class="infocontent">
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.deviceName") }}</div>
        <div class="infonumber" :title="devicein.name">
          {{ devicein.name }}
        </div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.deviceType") }}</div>
        <div class="infonumber" :title="deviceType(devicein.deviceType)">
          {{ deviceType(devicein.deviceType) }}
        </div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.deviceStatus") }}</div>
        <div class="infonumber" :title="deviceState(devicein.state)">
          <span :style="{ color: stateColor() }">{{ deviceState(devicein.state) }}</span>
        </div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.number") }}</div>
        <div class="infonumber" :title="devicein.completedCount">
          {{ devicein.completedCount }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
const screenSize = ref();
const width = window.innerWidth;
screenSize.value = width;
const { t } = useI18n();

const props = defineProps({
  devicein: { type: Object, required: true },
});
let state = ref(props.devicein.state);
let stateCode = ref(props.devicein.stateCode);
let devicein = props.devicein;

onMounted(() => {});

const stateColor = () => {
  return state.value == "0"
    ? "#e0bb00"
    : state.value == "1"
    ? "#009431"
    : state.value == "2"
    ? "#e0bb00"
    : state.value == "3"
    ? "#e00000"
    : "#0064c8";
};

function imageSource(type) {
  return type == "sheet"
    ? require("@/assets/img/device/C.png")
    : require("@/assets/img/device/Q.png");
}

function deviceType(type) {
  return props.devicein.deviceType == "sheet" ? t("index.sheet") : t("index.tube");
}

function deviceState(state) {
  return stateCode.value == "0" || stateCode.value == "1"
    ? t("index.wsState1")
    : stateCode.value == "2"
    ? t("index.wsState2")
    : stateCode.value == "3"
    ? t("index.wsState3")
    : stateCode.value == "4"
    ? t("index.wsState4")
    : stateCode.value == "5"
    ? t("index.wsState5")
    : stateCode.value == "6"
    ? t("index.wsState6")
    : stateCode.value == "7"
    ? t("index.wsState7")
    : stateCode.value == "8"
    ? t("index.wsState8")
    : t("index.wsState9");
}
</script>

<style scoped>
.info {
  display: flex;
  justify-content: space-between;
}
.deviceimg {
  height: 200px;
}
.verticalline {
  width: 1px;
  background-color: #e3e4e6;
  margin: 0px 30px;
}
.infocontent {
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  box-sizing: border-box;
  align-items: center;
}
.infoitems {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  height: 80px;
  position: relative;
  text-align: left;
  border-radius: 4px;
  padding: 12px;
  width: 48%;
  text-decoration: none;
  background: #f7f9fa;
  border: 1px solid transparent;
  transition: all 0.1s linear;
  margin-right: 10px;
}
.infoitems:hover {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
}
.infoitemsMin {
  width: 100% !important;
  margin-top: 10px !important;
}
.infotitle {
  line-height: 18px;
  height: 18px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  height: 18px;
}
.infonumber {
  display: block;
  line-height: 50px;
  height: 50px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
